import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../../contexts/SessionContext';
import API_URL from '../../constants/environment';
import { InventoryDetailResponse } from '../../types/inventory';

const getInventoryItem = async (
    sessionId: string,
    inventoryItemId: string,
): Promise<InventoryDetailResponse> => {
    const { data } = await axios.post(
        `${API_URL}/inventory/detail`,
        { inventoryItemId },
        { headers: { Authorization: sessionId } },
    );
    return data;
};

export const useGetInventoryItem = (inventoryItemId: string | undefined, enabled = true) => {
    const sessionContext = useContext(SessionContext);

    return useQuery({
        queryKey: ['/inventory/detail', inventoryItemId],
        queryFn: () => getInventoryItem(sessionContext?.sessionId ?? '', inventoryItemId!),
        enabled: !!sessionContext?.sessionId && !!inventoryItemId && enabled,
        staleTime: 30 * 1000,
        refetchOnWindowFocus: false,
    });
};
